import * as types from './types';
import createReducer from '../reducers';

const initialState = {
  data: {},
  loading: false,
  error: null,
};
const success = (state, { payload }) => ({
  ...state,
  data: payload,
  loading: false,
  error: null
});

const request = (state, { payload }) => ({
  ...state,
  loading: payload
});

const error = (state, { payload }) => ({
  ...state,
  error: payload,
  loading: false,
});

export default createReducer(initialState, {
  [types.REQUEST]: request,
  [types.SUCCESS]: success,
  [types.ERROR]: error,
});


// WEBPACK FOOTER //
// ./src/store/customer/reducer.js